var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPsdIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.45578 13.579H5.78847V17.7844H3.5V6H7.65194C10.251 6 12.2616 7.07831 12.2616 9.74326C12.2616 12.4698 10.1693 13.579 7.45578 13.579ZM5.78906 11.977H7.5708C9.10734 11.977 9.99004 11.2376 9.99004 9.75878C9.99004 8.20294 9.10734 7.58676 7.60349 7.58676H5.78906V11.977ZM16.871 9.37353C19.045 9.37353 20.1239 10.3286 20.2547 11.7766H18.2604C18.2114 11.1912 17.721 10.7599 16.8383 10.7599C15.972 10.7599 15.4652 11.1912 15.4652 11.7766C15.4652 12.3158 15.7922 12.593 16.5768 12.7009L17.9989 12.8857C19.6825 13.1014 20.4999 13.8254 20.4999 15.2888C20.4999 17.0603 18.9797 18 16.8547 18C14.5662 18 13.2912 17.0757 13.1768 15.4275H15.22C15.2854 16.0128 15.6614 16.6136 16.871 16.6136C17.8354 16.6136 18.4566 16.2131 18.4566 15.5353C18.4566 14.9807 18.2277 14.6726 17.296 14.5648L15.9229 14.3954C14.321 14.1951 13.422 13.4711 13.422 12.0077C13.422 10.5751 14.5825 9.37353 16.871 9.37353Z",
    fill: "#0070E0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPsdIcon);
export default __webpack_public_path__ + "static/media/psd-icon.1fa8321a.svg";
export { ForwardRef as ReactComponent };